import { NotFoundComponent } from './page-not-found.component';
import { CommonModule } from '@angular/common';

import { Route, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Route[] = [
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/404',
  },
  {
    path: '404',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
})
export class PageNotFoundModule {}
